
import { ShippingcostPrice } from '@models';

export class Shippingcost {
	id: number;
	title: string;
	name_nl: string;
	description_nl: string;
	name_en: string;
	description_en: string;
	name_fr: string;
	description_fr: string;
	name_de: string;
	description_de: string;
	created_at: string;
	updated_at: string;
	
	prices: ShippingcostPrice[];
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/shippingcost.ts